import Header from '../components/Header';
import MetaPixel from '../components/MetaPixel';

interface Props {
  children: React.ReactNode;
}

function BaseLayout({ children }: Props) {
  return (
    <div className="w-full bg-navy-20 min-h-[100vh]">
      <MetaPixel />
      <Header />
      {children}
    </div>
  );
}

export default BaseLayout;
